import { capitalize } from 'lodash';
import { RosteredStatus, ActivityStatus } from './activity-types';

export const getActivityLegend = (status: ActivityStatus | RosteredStatus) => {
  if (status === 'unsure') {
    return 'Not indicated'
  }
  return capitalize(status);
}
